import React from "react";
import { Wrapper, Container } from "../styles/components/Global/Global";
import {
  ImageContainer,
  Image,
  GalleryWrapper,
  TextContainer,
  CoordinateText,
} from "../styles/components/Galleries/Stacked";

const GalleryStacked = () => {
  return (
    <Wrapper>
      <Container $justify="flex-start" $height="auto" $flex>
        <GalleryWrapper>
          <ImageContainer $margin>
            <Image
              src="https://www.datocms-assets.com/40484/1695303432-01004_eletre_campaign_s007_speaker_comp03_re_finalart.png"
              $fullWidth
            />
            <TextContainer $justify="flex-start">
              <CoordinateText>48.8566° N, 2.3522° E</CoordinateText>
            </TextContainer>
          </ImageContainer>
          <ImageContainer $justify="flex-end">
            <TextContainer $justify="flex-end">
              <CoordinateText>48.8566° N, 2.3522° E</CoordinateText>
            </TextContainer>
            <Image src="https://www.datocms-assets.com/40484/1695303464-01004_eletre_campaign_s021_centre_console_comp02_re_finalart_lotus.png" />
          </ImageContainer>
        </GalleryWrapper>
      </Container>
    </Wrapper>
  );
};

export default GalleryStacked;
